import classNames from 'classnames';

import useStyles from './styles';

const FAQFallback = () => {
  const styles = useStyles();
  return (
    <div className={styles.rootFallback}>
      <i className={classNames(styles.titleFallback, 'skeleton')} />

      {[...Array(4)].map((i, index) => (
        <i
          className={classNames(
            styles.itemFallback,
            { [styles.openedItemFallback]: !i },
            'skeleton',
          )}
          key={`faq-${i}-${index}`}
        />
      ))}
    </div>
  );
};

export default FAQFallback;
